export default function Logo() {
  return (
    <div className="logo">
      <img
        src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png"
        alt="Google"
      />
    </div>
  );
}
